<template>
  <div class="row" style="overflow-x: auto">
    <CommentsSideCard :route="this.route" />
    <div class="col">
      <div class="card p-5 comment-page-content">
        <div class="chat-container">
          <b-overlay :show="blurLoading" variant="transparent" :opacity="1">
            <ViewCommentContainer v-if="commentX" :comment="commentX" @approve="approve" @ignore="ignore" @reply="reply" />
            <div v-if="commentX && commentX.children.length > 0" class="ps-5 mt-5">
              <hr />
              <ViewCommentContainer :comment="commentX.children[0]" children="true" />
            </div>
            <div v-if="!showReply && commentX" class="mt-5">
              <button class="btn btn-secondary py-2 px-3 me-2" @click="reply">{{ $t('comment.reply') }} <i class="align-middle fa fa-reply ms-1" /></button>
            </div>
            <div v-if="showReply">
              <hr />
              <div class="message-container d-flex flex-column mt-4">
                <div class="align-items-center d-flex mb-4">
                  <img
                    v-if="$store.state.idp.userProfileData.image"
                    class="rounded-circle"
                    :src="$store.state.idp.userProfileData.image"
                    alt="Header Avatar"
                    width="60"
                    height="60"
                  />
                  <img v-else class="rounded-circle" src="../../assets/images/users/avatar-1.jpg" alt="Header Avatar" width="60" height="60" />
                  <div class="fs-5 ms-4">
                    <div class="name">{{ $store.state.idp.userProfileData.firstname }} {{ $store.state.idp.userProfileData.lastname }}</div>
                  </div>
                </div>
              </div>
              <form @submit="onSubmit" class="my-3 d-block">
                <div class="align-items-center d-flex mb-4">
                  <p class="my-0 me-5">{{ $t('comment.reply') }}</p>
                  <textarea required :placeholder="$t('comment.placeholder')" v-model="message" class="form-control" />
                </div>
                <div class="text-end">
                  <button class="btn btn-secondary py-2 px-3 me-2" @click="closeReply">{{ $t('comment.cancel') }}</button>
                  <button class="btn btn-primary py-2 px-5 me-2" @click="submitReply">{{ $t('comment.submit') }}</button>
                </div>
              </form>
            </div>
          </b-overlay>
        </div>
        <Toast :title="toastText" :error="toastMode" :showToast="showToast" />
      </div>
    </div>
  </div>
</template>

<script>
import commentDataProvider from '../../services/comment'
import ViewCommentContainer from './ViewCommentContainer'
import Toast from '../common/Toast'
import CommentsSideCard from './SideCard'

export default {
  name: 'comment',
  components: { ViewCommentContainer, Toast, CommentsSideCard },
  data() {
    return {
      message: null,
      commentType: 3,
      blurLoading: false,
      commentLoading: false,
      commentX: null,
      showReply: false,
      toastText: '',
      toastMode: false,
      showToast: null,
    }
  },
  mounted() {
    this.getComment(this.$route.params.commentId, this.$route.params.courseId ? 'AdminCourse/Comment/' : 'AdminPackage/Comment/').then((res) => {
      this.$data.commentX = res
    })
  },
  methods: {
    submitReply() {
      commentDataProvider
        .postCommentReply(
          this.$route.params.courseId
            ? {
                courseId: +this.$route.params.courseId,
                parentId: this.$data.commentX.id,
                description: this.message,
                userId: this.$store.state.idp.userProfileData.id,
              }
            : {
                packageId: +this.$route.params.packageId,
                parentId: this.$data.commentX.id,
                description: this.message,
                userId: this.$store.state.idp.userProfileData.id,
              },
          this.$route.params.courseId ? 'AdminCourse/CommentReply' : 'AdminPackage/CommentReply',
        )
        .then((res) => {
          this.toastText = 'پاسخ ارسال شد'
          this.getComment(this.$route.params.commentId, this.$route.params.courseId ? 'AdminCourse/Comment/' : 'AdminPackage/Comment/').then((res) => {
            this.$data.commentX = res
          })
          this.toastMode = false
          this.showToast = true
          setTimeout(() => {
            // this.$router.go(-1)
            this.flushToast()
          }, 2002)
        })
        .catch((error) => {
          this.toastText = 'مشکلی پیش آمده است.'
          this.toastMode = false
          this.showToast = true
          setTimeout(() => {
            // this.$router.go(-1)
            this.flushToast()
          }, 2002)
        })
    },
    reply() {
      this.showReply = true
    },
    closeReply() {
      this.showReply = false
    },
    approve() {
      commentDataProvider
        .putCommentStatus({ id: this.$route.params.commentId.toString(), status: '2' }, this.$route.params.courseId ? 'AdminCourse/CommentStatus' : 'AdminPackage/CommentStatus')
        .then((res) => {
          this.toastText = 'پیام تایید شد'
          this.toastMode = false
          this.showToast = true
          this.getComment(this.$route.params.commentId, this.$route.params.courseId ? 'AdminCourse/Comment/' : 'AdminPackage/Comment/').then((res) => {
            this.$data.commentX = res
          })
          setTimeout(() => {
            // this.$router.go(-1)
            this.flushToast()
          }, 2002)
        })
        .catch((error) => {
          this.toastText = 'مشکلی پیش آمده است.'
          this.toastMode = false
          this.showToast = true
          setTimeout(() => {
            // this.$router.go(-1)
            this.flushToast()
          }, 2002)
        })
    },
    ignore() {
      commentDataProvider
        .putCommentStatus({ id: this.$route.params.commentId.toString(), status: '3' }, this.$route.params.courseId ? 'AdminCourse/CommentStatus' : 'AdminPackage/CommentStatus')
        .then((res) => {
          this.toastText = 'پیام رد شد'
          this.toastMode = false
          this.showToast = true
          this.getComment(this.$route.params.commentId, this.$route.params.courseId ? 'AdminCourse/Comment/' : 'AdminPackage/Comment/').then((res) => {
            this.$data.commentX = res
          })
          setTimeout(() => {
            // this.$router.go(-1)
            this.flushToast()
          }, 2002)
        })
        .catch((error) => {
          this.toastText = 'مشکلی پیش آمده است.'
          this.toastMode = false
          this.showToast = true
          setTimeout(() => {
            // this.$router.go(-1)
            this.flushToast()
          }, 2002)
        })
    },
    onSubmit(e) {
      e.preventDefault()
    },
    getComment(id) {
      this.goUp = false
      return commentDataProvider
        .getComment(id, this.$route.params.courseId ? 'AdminCourse/Comment/' : 'AdminPackage/Comment/')
        .then((res) => {
          const response = res.data.data.output
          this.blurLoading = false
          this.commentLoading = false
          return response
        })
        .catch((error) => {})
    },
  },
  watch: {},
  beforeDestroy() {
    this.$store.dispatch('comment/flushComments')
  },
}
</script>

<style scoped lang="scss">
@import '../../design/globalCss.scss';
.alert {
  padding: 0;
}
textarea {
  height: 200px;
}
h1 {
  font-family: IRANSans-bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  color: $dark-color;
  margin-bottom: 16px;
}
.chat {
  background-color: white;
  min-width: 100%;
  padding: 16px;
}
.chat-container {
  width: 100%;
  // position: relative;
}
form {
  display: flex;
  align-items: center;
}
input {
  width: 100%;
  padding: 8px;
  border: none;
  outline: none;
  background: #fafafa;
  border-radius: 100px;
  flex: 2;
}
</style>
